import React from 'react';
import { render } from 'react-dom';
import { dispatch } from 'reffects';
import { subscribe } from 'reffects-store';
import Button from 'components/library/Button/Button';
import {
    isCookiePolicyDialogVisibleSelector,
    isCookiePolicySubmitting,
} from 'components/CookiePolicyDialog/selectors';
import './CookiePolicyDialog.css';
import SpinnerIcon from 'components/library/Icons/SpinnerIcon';
import { i18n } from 'utils/translate';
import registerCookiePolicyDialogEvents from './events';

function CookiePolicyDialog({ isVisible, isDocumentSubmitting }) {
    if (!isVisible) {
        return null;
    }

    return (
        <div className="CookiePolicyDialog">
            {i18n('accept_cookie_policy_intro')}
            <div className="CookiePolicyDialog__footer">
                <a
                    href="/index.php/cod.accepted-cookie-policy"
                    title="cookie policy document"
                >
                    {i18n('accept_cookie_policy_link')}
                </a>
                <div>
                    <Button
                        color="primary"
                        onClick={() => dispatch('COOKIE_POLICY_REJECTED')}
                    >
                        {i18n('accept_cookie_policy_decline')}
                    </Button>
                    <Button
                        variant="flat"
                        color="primary"
                        disabled={isDocumentSubmitting}
                        onClick={() => dispatch('COOKIE_POLICY_WAS_ACCEPTED')}
                    >
                        {isDocumentSubmitting && <SpinnerIcon />}
                        {i18n('accept_cookie_policy_accept')}
                    </Button>
                </div>
            </div>
        </div>
    );
}

const SubscribedCookiePolicyDialog = subscribe(
    CookiePolicyDialog,
    function mapStateToProps(state) {
        return {
            isVisible: isCookiePolicyDialogVisibleSelector(state),
            isDocumentSubmitting: isCookiePolicySubmitting(state),
        };
    }
);

export default function cookiePolicyDialog() {
    const element = document.getElementById('js-cookie-policy-dialog');
    if (!element) {
        return;
    }

    registerCookiePolicyDialogEvents();
    dispatch('INITIALIZE_COOKIE_POLICY_DIALOG');

    render(
        <SubscribedCookiePolicyDialog />,
        document.getElementById('js-cookie-policy-dialog')
    );
}
